import React from 'react';
import PropTypes from 'prop-types';
import styles from './InsightsParagraph.module.less';
import AnalyticsHandler from '../../../Utils/AnalyticsHandler/AnalyticsHandler';
import AnalyticsEventNames from '../../../Utils/AnalyticsHandler/AnalyticsEventNames';

const InsightsParagraph = (props) => {
  const { totalSubscriptions, availableSubscriptions, isTrial } = props;
  const noSubscriptions = totalSubscriptions === 0 || !totalSubscriptions;
  const totalSeatsText = `${totalSubscriptions} Search Insights `;
  const assignedSeats = totalSubscriptions - availableSubscriptions;
  const noSeatsDiv = <span>{gettext('Your subscription has expired. ')}</span>;
  const seatsDiv = (
    <span className={styles.seatsText}>
      {gettext(`You have `)}
      <b>{totalSeatsText}</b>
      {gettext(
        `seat${
          totalSubscriptions > 1 ? 's' : ''
        } (${assignedSeats} assigned and ${availableSubscriptions} available). `,
      )}
    </span>
  );
  return (
    <div>
      <div className={styles.header}>{gettext('Search Insights')}</div>
      <div className={styles.insightsWrapper}>
        {noSubscriptions ? noSeatsDiv : seatsDiv}
        {!isTrial ? (
          <AnalyticsHandler eventName={AnalyticsEventNames.CLICK_EXPAND_SUBSCRIPTION_LINK}>
            <a className={styles.link} target="_blank" href={`${window.location.origin}/manage/upgrade/`}>
              {gettext('Add seats.')}
            </a>
          </AnalyticsHandler>
        ) : (
          <>
          <AnalyticsHandler eventName={AnalyticsEventNames.CLICK_CONTACT_US_LINK}>
            <a className={styles.link} target="_blank" href="https://pipl.com/contact-us">
              {gettext('Contact us ')}
            </a>
          </AnalyticsHandler>
          <span>{gettext('to get additional seats.')}</span>
          </>
        )}
      </div>
    </div>
  );
};

InsightsParagraph.propTypes = {
  totalSubscriptions: PropTypes.number,
  availableSubscriptions: PropTypes.number,
  isTrial: PropTypes.bool,
};
export default InsightsParagraph;
